import React, { useEffect, useState } from 'react';
import { Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
const checkoutBasico = 'https://checkout.recursodigital.shop/cart/41319539540026:1';
const checkoutCompleto = 'https://checkout.recursodigital.shop/cart/41319548846138:1';
export function FinalCTA() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 46,
    seconds: 34
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 23,
          minutes: 59,
          seconds: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (v: number) => v.toString().padStart(2, '0');
  return <section className="bg-brand-dark text-white py-5 px-5" data-id="element-107">
      <div className="max-w-xl mx-auto" data-id="element-108">
        {/* Headline */}
        <h2 className="text-xl md:text-3xl font-extrabold mb-10 leading-tight text-center" data-id="element-109">
          El próximo lunes podés seguir improvisando…{' '}
          <span className="text-brand-yellow" data-id="element-110">
            o podés tener todo listo desde hoy.
          </span>
        </h2>

        {/* Countdown Timer */}
        <div className="text-center mb-10" data-id="element-111">
          <p className="text-sm text-gray-400 mb-4 font-medium" data-id="element-112">
            🚨 El precio de lanzamiento cierra en:
          </p>
          <div className="flex items-end justify-center gap-1 mb-2" data-id="element-113">
            <div className="text-center" data-id="element-114">
              <span className="text-5xl md:text-6xl font-black text-white" data-id="element-115">
                {fmt(timeLeft.hours)}
              </span>
              <p className="text-[10px] text-gray-500 uppercase tracking-wider mt-1" data-id="element-116">
                HS
              </p>
            </div>
            <span className="text-4xl md:text-5xl font-black text-brand-yellow pb-1" data-id="element-117">
              :
            </span>
            <div className="text-center" data-id="element-118">
              <span className="text-5xl md:text-6xl font-black text-white" data-id="element-119">
                {fmt(timeLeft.minutes)}
              </span>
              <p className="text-[10px] text-gray-500 uppercase tracking-wider mt-1" data-id="element-120">
                MIN
              </p>
            </div>
            <span className="text-4xl md:text-5xl font-black text-brand-yellow pb-1" data-id="element-121">
              :
            </span>
            <div className="text-center" data-id="element-122">
              <span className="text-5xl md:text-6xl font-black text-white" data-id="element-123">
                {fmt(timeLeft.seconds)}
              </span>
              <p className="text-[10px] text-gray-500 uppercase tracking-wider mt-1" data-id="element-124">
                SEG
              </p>
            </div>
          </div>
          <p className="text-xs text-gray-500 mt-3" data-id="element-125">
            Después sube{' '}
            <span className="text-red-400 font-bold" data-id="element-126">S/.30.00 PEN</span> y no
            vuelve.
          </p>
        </div>

        {/* Two pricing cards side by side */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6" data-id="element-127">
          {/* Basic */}
          <div className="bg-gray-900 border border-gray-700 rounded-xl p-5 text-center flex flex-col" data-id="element-128">
            <div className="text-3xl mb-2" data-id="element-129">📘</div>
            <h4 className="text-sm font-black text-white uppercase mb-1" data-id="element-130">
              MEGAPACK INICIAL
            </h4>
            <p className="text-[11px] text-gray-500 mb-4" data-id="element-131">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-132">
              <div className="text-xs text-gray-600 line-through mb-0.5" data-id="element-133">
                S/.49.90
              </div>
              <div className="text-2xl font-black text-white mb-4" data-id="element-134">
                S/.29.90
              </div>
              <a href={checkoutBasico} className="block w-full border-2 border-brand-yellow text-brand-yellow font-black text-sm py-3 px-4 rounded-xl hover:bg-brand-yellow/10 transition-colors text-center" data-id="element-135">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          {/* Complete */}
          <div className="bg-gray-900 border-2 border-brand-yellow rounded-xl p-5 text-center flex flex-col" data-id="element-136">
            <div className="text-3xl mb-2" data-id="element-137">🏆</div>
            <h4 className="text-sm font-black text-white uppercase mb-1" data-id="element-138">
              MEGAPACK + AULA LISTA ⭐
            </h4>
            <p className="text-[11px] text-gray-400 mb-4" data-id="element-139">
              6 Tomos + 6 Bonos + Aula Lista™
            </p>
            <div className="mt-auto" data-id="element-140">
              <div className="text-xs text-gray-600 line-through mb-0.5" data-id="element-141">
                S/.99.90
              </div>
              <div className="text-2xl font-black text-white mb-4" data-id="element-142">
                S/.69.90
              </div>
              <a href={checkoutCompleto} className="block w-full bg-brand-yellow hover:bg-brand-yellowHover text-black font-black text-sm py-3 px-4 rounded-xl shadow-[0_4px_14px_0_rgba(251,191,36,0.3)] transition-all hover:scale-[1.02] text-center" data-id="element-143">
                → QUIERO EL MEGAPACK + AULA LISTA
              </a>
            </div>
          </div>
        </div>

        {/* Trust badges */}
        <div className="text-center space-y-2 mt-8" data-id="element-144">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-semibold text-gray-400" data-id="element-145">
            <div className="flex items-center gap-1.5" data-id="element-146">
              <Lock size={13} className="text-brand-yellow" data-id="element-147" />
              Pago 100% seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-148">
              <Zap size={13} className="text-brand-yellow" data-id="element-149" />
              Acceso en 5 minutos
            </div>
            <div className="flex items-center gap-1.5" data-id="element-150">
              <ShieldCheck size={13} className="text-brand-yellow" data-id="element-151" />
              Garantía 7 días sin preguntas
            </div>
          </div>
          <div className="flex items-center justify-center gap-1.5 text-[11px] text-gray-500" data-id="element-152">
            <CreditCard size={13} className="text-brand-yellow" data-id="element-153" />
            Tarjeta de crédito | Transferencia bancaria
          </div>
        </div>
      </div>
    </section>;
}